<script setup>
// Thin project-scoped wrapper around the generic DocumentRequestsPanel.
import DocReqAPI from 'dashboard/api/projectDocumentRequests';
import ProjectsAPI from 'dashboard/api/projects';
import DocumentRequestsPanel from 'dashboard/components/documents/DocumentRequestsPanel.vue';

const props = defineProps({
  projectId: {
    type: [String, Number],
    required: true,
  },
});

const emit = defineEmits(['count']);

const shareFn = id => ProjectsAPI.generateDocumentRequestShare(id);
</script>

<template>
  <DocumentRequestsPanel
    :api="DocReqAPI"
    :owner-id="props.projectId"
    :share-fn="shareFn"
    @count="emit('count', $event)"
  />
</template>
